import React from 'react';
import { NavLink } from 'react-router-dom';
import { X, Settings, Cpu, FolderOpen, LayoutDashboard, LogOut, Info } from 'lucide-react';

export default function Sidebar({ isOpen, onClose, user, handleLogout }) {

  // פונקציית עזר למניעת חזרתיות על עיצוב הקישורים
  const linkClass = ({ isActive }) =>
    `w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-xl text-right transition-colors ${isActive
      ? 'text-indigo-600 bg-indigo-50/50'
      : 'text-slate-600 hover:bg-slate-50'
    }`;

  return (
    <>
      {/* מסך חשוך ברקע (Overlay) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm z-50 transition-opacity duration-300"
          onClick={onClose}
        />
      )}

      {/* תפריט הצד */}
      <aside className={`fixed top-0 right-0 h-full w-72 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-out p-6 flex flex-col border-l border-slate-100 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>

        {/* כותרת התפריט וכפתור סגירה */}
        <div className="flex items-center justify-between mb-8">
          <h2 className="font-bold text-slate-900 text-lg">תפריט ניהול</h2>
          <button onClick={onClose} className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-slate-600 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* ניווט ראשי - גוף התפריט */}
        <nav className="space-y-1 flex-1">




          <NavLink to="/agent" onClick={onClose} className={linkClass}>
            <div className="flex items-center gap-3">
              <Cpu className="w-4 h-4" />
              <span>סוכן קבלות</span>
            </div>
          </NavLink> 

          <NavLink to="/files" onClick={onClose} className={linkClass}>
            <div className="flex items-center gap-3">
              <FolderOpen className="w-4 h-4" />
              <span>הקבצים שלי</span>
            </div>
          </NavLink>


          <NavLink to="/settings" onClick={onClose} className={linkClass}>
            <div className="flex items-center gap-3">
              <Settings className="w-4 h-4 text-slate-300" />
              <span>הגדרות מערכת</span>
            </div>
          </NavLink>



          {/* <NavLink
            to="/settings" // מונע ניווט אמיתי
            onClick={(e) => e.preventDefault()} // חוסם את הלחיצה לחלוטין
            className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-xl text-right transition-colors text-slate-400 bg-slate-50/50 cursor-not-allowed pointer-events-none select-none"
          >
            <div className="flex items-center gap-3">
              <Settings className="w-4 h-4 text-slate-300" />
              <span>הגדרות מערכת</span>
            </div>
            <span className="px-2 py-0.5 text-[10px] font-bold tracking-wide text-slate-500 bg-slate-100 border border-slate-200 rounded-md">
              בקרוב
            </span>
          </NavLink> */}

          <NavLink
            to="#" // מונע ניווט אמיתי
            onClick={(e) => e.preventDefault()} // חוסם את הלחיצה לחלוטין
            className="w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-xl text-right transition-colors text-slate-400 bg-slate-50/50 cursor-not-allowed pointer-events-none select-none"
          >
            <div className="flex items-center gap-3">
              <LayoutDashboard className="w-4 h-4 text-slate-300" />
              <span>לוח בקרה</span>
            </div>
            <span className="px-2 py-0.5 text-[10px] font-bold tracking-wide text-slate-500 bg-slate-100 border border-slate-200 rounded-md">
              בקרוב
            </span>
          </NavLink>

   
        </nav>

        {/* חלק תחתון - אזור משתמש, מידע משפטי וגרסה */}
        <div className="border-t border-slate-100 pt-4 mt-auto space-y-4">

          {/* תצוגת פרופיל גוגל (אם המשתמש מחובר) */}
          {user && (
            <div className="flex items-center gap-3 px-3 py-2 bg-slate-50 rounded-xl border border-slate-100 text-right" dir="rtl">
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-8 h-8 rounded-full border border-slate-200"
                  referrerPolicy="no-referrer"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold text-xs">
                  {user.name?.[0] || 'U'}
                </div>
              )}
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-xs font-semibold text-slate-800 truncate">{user.name}</span>
                <span className="text-[10px] text-slate-400 truncate">{user.email}</span>
              </div>
            </div>
          )}

          {/* כפתור התנתקות מהמערכת */}
          <button
            onClick={() => {
              if (onClose) onClose();
              handleLogout();
            }}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-xl text-right transition-colors text-rose-600 hover:bg-rose-50 hover:text-rose-700"
          >
            <LogOut className="w-4 h-4" />
            <span>התנתקות מהמערכת</span>
          </button>

          {/* קישורים משפטיים קטנים עבור גוגל */}
          <div className="flex items-center justify-center gap-3 text-[11px] text-slate-400 border-t border-slate-100 pt-3">
            <NavLink to="/privacy" onClick={onClose} className="hover:text-indigo-600 transition-colors underline">
              מדיניות פרטיות
            </NavLink>
            <span className="text-slate-200">•</span>
            <NavLink to="/terms" onClick={onClose} className="hover:text-indigo-600 transition-colors underline">
              תנאי שימוש
            </NavLink>
          </div>

          {/* חיווי גרסה מערכת */}
          <div className="flex items-center gap-2 text-[11px] text-slate-400 justify-center bg-slate-50/50 py-1.5 rounded-lg border border-slate-100/50">
            <Info className="w-3.5 h-3.5 text-slate-400" />
            <span>גרסה 1.0.0 (Localhost)</span>
          </div>

        </div>
      </aside>
    </>
  );
}